import React, { Component } from 'react';
import { Modal, Header, Button, Input, TextArea, Label, Segment } from 'semantic-ui-react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { connect } from 'react-redux';
import { firebaseConnect, pathToJS, isLoaded } from 'react-redux-firebase';
import moment from 'moment';
import { uploadFile } from './actions';
import './index.css';


class AddEntryModalButton extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
      values: {},
      isSubmitting: false,
    };
    this.onChange = (e, { name, value }) => {
      this.setState({ values: { ...this.state.values, [name]: value } });
    };
    this.files = {};
    this.numberOfFiles = 0;
    this.numberOfFilesSubmitted = 0;
  }
  submitData(firebase) {
    const newEntry = {
      values: this.state.values,
      tableId: this.props.tableId,
    };
    this.props.firebase.push('/rows/', newEntry);
    this.closeModal();
  }
  tryToSubmitData(firebase, name, data) {
    this.numberOfFilesSubmitted += 1;

    const valuesClone = { ...this.state.values };
    delete valuesClone[name];
    this.setState({ values: valuesClone });

    const originalName = name.split('|')[0];
    const newValues = this.state.values[originalName] ?
    [...this.state.values[originalName], data] : [data];

    this.setState({ values: { ...this.state.values, [originalName]: newValues } });

    if (this.numberOfFiles === this.numberOfFilesSubmitted) {
      this.submitData(firebase);
    }
  }
  onClickSubmit() {
    this.setState({ isSubmitting: true });
    const nameList = Object.keys(this.state.values);
    const values = { ...this.state.values };
    const { firebase } = this.props;

    this.numberOfFiles = nameList.filter(name => values[name] instanceof File).length;
    if (this.numberOfFiles > 0) {
      nameList.forEach((name) => {
        if (values[name] instanceof File) {
          uploadFile(firebase, values, name,
           data => this.tryToSubmitData(firebase, name, data));
        }
      });
    } else {
      this.submitData(firebase);
    }
  }
  getDatePicker(column, i) {
    return (
      <Segment>
        <Label attached="top">{column.title}:</Label>
        <DayPickerInput
          fluid
          placeholder="Please select a date..."
          onDayChange={day => this.onChange(null, { name: column.title, value: moment(day).format('YYYY-MM-DD') })}
          key={i}
        />
      </Segment>
    );
  }
  getTextInput(column, i) {
    return (
      <Segment>
        <Label attached="top">{column.title}:</Label>
        <TextArea
          autoHeight
          rows={3}
          name={column.title}
          placeholder="Enter text in here..."
          value={this.state[column.title]}
          onChange={(e, data) => this.onChange(e, { ...data, value: data.value.trim() })}
          key={i}
        />
      </Segment>
    );
  }
  fileInputOnChange(e, data, column, name) {
    this.onChange(e, { name, value: e.target.files[0] });
    if (!e.target.files[0]) {
      const valuesClone = { ...this.state.values };
      delete valuesClone[name];
      this.setState({ values: valuesClone });
    }
  }
  getFileInput(column, i) {
    return (
      <div>
        <Segment>
          <Label attached="top">{column.title}:</Label>
          <Input
            name={`${column.title}|1`}
            value={this.state[`${column.title}|1`]}
            onChange={(e, data) => this.fileInputOnChange(e, data, column, `${column.title}|1`)}
            key={i}
            type="file"
            ref={ref => this.files[`${column.title}|1`] = ref}
          />
          <Input
            name={`${column.title}|2`}
            value={this.state[`${column.title}|2`]}
            onChange={(e, data) => this.fileInputOnChange(e, data, column, `${column.title}|2`)}
            key={`${i}a`}
            type="file"
            ref={ref => this.files[`${column.title}|2`] = ref}
          />
          <Input
            name={`${column.title}|3`}
            value={this.state[`${column.title}|3`]}
            onChange={(e, data) => this.fileInputOnChange(e, data, column, `${column.title}|3`)}
            key={`${i}b`}
            type="file"
            ref={ref => this.files[`${column.title}|3`] = ref}
          />
          <Input
            name={`${column.title}|4`}
            value={this.state[`${column.title}|4`]}
            onChange={(e, data) => this.fileInputOnChange(e, data, column, `${column.title}|4`)}
            key={`${i}c`}
            type="file"
            ref={ref => this.files[`${column.title}|4`] = ref}
          />
        </Segment>
      </div>
    );
  }

  getInputs() {
    return this.props.columns.map((column, i) => {
      switch (column.dataType) {
        case 'text':
          return this.getTextInput(column, i);
        case 'date':
          return this.getDatePicker(column, i);
        case 'file':
          return this.getFileInput(column, i);
        case 'link':
          return this.getTextInput(column, i);
      }
      return null;
    });
  }
  openModal() { this.setState({ isOpen: true }); }
  closeModal() {
    this.files = {}; this.setState({ isOpen: false, values: {}, isSubmitting: false });
    this.numberOfFilesSubmitted = 0;
  }
  render() {
    if (!isLoaded(this.props.auth) || !this.props.auth) return <div />;
    return (
      <Modal
        trigger={<Button fluid onClick={() => this.openModal()}> Add an Entry </Button>}
        open={this.state.isOpen}
        dimmer="blurring"
      >
        <Header content="Add an Entry" />
        <Modal.Content>{this.getInputs()}</Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.closeModal()}>Cancel</Button>
          <Button
            primary
            onClick={() => this.onClickSubmit()}
            loading={this.state.isSubmitting}
            disabled={this.state.isSubmitting}
          >Create Entry</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default connect(({ firebase }) => ({
  auth: pathToJS(firebase, 'auth'),
}))(firebaseConnect()(AddEntryModalButton));



// WEBPACK FOOTER //
// ./src/modules/AddEntryModalButton/container.js